export default __webpack_public_path__ + "static/media/logo.165da9c2.png";